import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 39 39",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1 19.625a18.375 18.375 0 1 0 36.75 0 18.375 18.375 0 0 0-36.75 0Z",
			fill: "#52C41A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 19.625a18.375 18.375 0 1 0 36.75 0 18.375 18.375 0 0 0-36.75 0v0Z",
			stroke: "#135200",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.348 29.451a2.89 2.89 0 0 1-2.05-.848l-5.795-5.795a2.899 2.899 0 0 1 4.1-4.099l3.747 3.749 11.8-11.803a2.899 2.899 0 0 1 4.1 4.1l-13.852 13.85a2.885 2.885 0 0 1-2.05.845Z",
			fill: "#fff",
			stroke: "#135200",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.2
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2039%2039%22%3E%3Cpath%20d%3D%22M1%2019.625a18.375%2018.375%200%201%200%2036.75%200%2018.375%2018.375%200%200%200-36.75%200Z%22%20fill%3D%22%2352C41A%22%2F%3E%3Cpath%20d%3D%22M1%2019.625a18.375%2018.375%200%201%200%2036.75%200%2018.375%2018.375%200%200%200-36.75%200v0Z%22%20stroke%3D%22%23135200%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.2%22%2F%3E%3Cpath%20d%3D%22M15.348%2029.451a2.89%202.89%200%200%201-2.05-.848l-5.795-5.795a2.899%202.899%200%200%201%204.1-4.099l3.747%203.749%2011.8-11.803a2.899%202.899%200%200%201%204.1%204.1l-13.852%2013.85a2.885%202.885%200%200%201-2.05.845Z%22%20fill%3D%22%23fff%22%20stroke%3D%22%23135200%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.2%22%2F%3E%3C%2Fsvg%3E";
